import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TipsPaymentsManagerComponent } from './tips-payments-manager.component';
import { FormsModule } from '@angular/forms';

import { SaleCheckoutButtonsComponentModule } from '../sale-checkout-buttons/sale-checkout-buttons.module';
import { SaleTotalSummaryComponentModule } from '../sale-total-summary/sale-total-summary.module';
import { SharedModule } from '../../../../shared.module';
@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    SaleCheckoutButtonsComponentModule,
    SaleTotalSummaryComponentModule,
    SharedModule
  ],
  declarations: [TipsPaymentsManagerComponent],
  exports: [TipsPaymentsManagerComponent]
})
export class TipsPaymentsManagerComponentModule {}